import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import VueRouter from 'vue-router'
import store from './store'
import Vuex from 'vuex'
import router from './router'
// import routes from './routes'
import  axios from 'axios'
import common from './common/index'
import Moment from 'moment'
import 'font-awesome/css/font-awesome.min.css'
import '@/permission' // 权限
import '../static/css/globel.css'
Vue.use(ElementUI)
Vue.filter('convertDate', function(value) {
  return Moment(value).format('YYYY-MM-DD')
})
// Vue.use(VueRouter)
Vue.use(Vuex)
Vue.prototype.common = common
Vue.prototype.$http = axios
// axios.defaults.baseURL = 'http://192.168.1.223:8092/managementSystem/'
// axios.defaults.baseURL = 'http://192.168.1.10:8091/managementSystem/'

// axios.defaults.baseURL = 'http://localhost:8091/managementSystem/'
// axios.defaults.baseURL = 'http://192.168.1.181:8091/managementSystem/'
// axios.defaults.baseURL = 'https://card.xmgrwhg.org/managementSystem/'
axios.defaults.baseURL = 'https://zlesp.zlydgy.cn:443/managementSystem/'//新
// axios.defaults.baseURL = 'http://192.168.1.131:8092/managementSystem/'
// axios.defaults.baseURL = 'https://cs.xmgrwhg.org/managementSystem/'
// axios.defaults.baseURL = 'https://www.dooop.top/managementSystem/'
// axios.defaults.baseURL = 'https://localhost/managementSystem/'
// axios.defaults.baseURL = 'https://gymvip.bfsu.edu.cn/managementSystem/'
// axios.defaults.baseURL = 'https://www.dooop.top/managementSystem/',
// axios.defaults.baseURL = 'https://www.147soft.cn/managementSystem/'
// axios.defaults.baseURL = 'https://www.wuhansport.com/managementSystem/'

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


// var routeList = [];
// router.beforeEach((to, from, next) => {
//   var index = -1;
//   for(var i = 0; i < routeList.length; i++) {
//     if(routeList[i].name == to.name) {
//       index = i;
//       break;
//     }
//   }
//   if (index !== -1) {
//     //如果存在路由列表，则把之后的路由都删掉
//     routeList.splice(index + 1, routeList.length - index - 1);
//   } else if(to.name != '登录'){
//     routeList.push({"name":to.name,"path":to.fullPath});
//   }
//     to.meta.routeList = routeList;
//   next()
// });




// WEBPACK FOOTER //
// ./src/main.js